/**
 * @fileoverview Utilitarios de variaveis de template Meta ({{N}}).
 *
 * Centraliza a deteccao/substituicao posicional usada por TemplateModal,
 * Flows/FlowBuilder/panels/TemplateVariableMapper e MetaTemplates.
 */

/**
 * Retorna a lista de numeros unicos de variaveis presentes no texto,
 * ordenados crescentemente como strings ("1", "2", ...).
 *
 *   extractTemplateVars("Ola {{1}}, seu {{2}}") -> ["1", "2"]
 */
export const extractTemplateVars = (text) => {
  if (!text || typeof text !== "string") return [];
  const set = new Set();
  const re = /\{\{(\d+)\}\}/g;
  let m;
  while ((m = re.exec(text)) !== null) set.add(m[1]);
  return Array.from(set).sort((a, b) => Number(a) - Number(b));
};
